import React from 'react';
import { TimeSlot } from './types';

interface TimeSlotInputProps {
  slot: TimeSlot;
  index: number;
  disabled: boolean;
  showRemove: boolean;
  onUpdate: (index: number, field: 'startTime' | 'endTime', value: string) => void;
  onRemove: (index: number) => void;
}

const TimeSlotInput: React.FC<TimeSlotInputProps> = ({
  slot,
  index,
  disabled,
  showRemove,
  onUpdate,
  onRemove,
}) => {
  return (
    <div className="flex items-center gap-2">
      <input
        type="time"
        value={slot.startTime}
        onChange={(e) => onUpdate(index, 'startTime', e.target.value)}
        disabled={disabled}
        className={`px-2 py-1 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-[#3A5E63] focus:border-[#3A5E63] ${
          disabled ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-white'
        }`}
      />
      <span className={`text-sm ${disabled ? 'text-gray-400' : 'text-gray-600'}`}>-</span>
      <input
        type="time"
        value={slot.endTime}
        onChange={(e) => onUpdate(index, 'endTime', e.target.value)}
        disabled={disabled}
        className={`px-2 py-1 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-[#3A5E63] focus:border-[#3A5E63] ${
          disabled ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-white'
        }`}
      />
      {showRemove && !disabled && (
        <button
          type="button"
          onClick={() => onRemove(index)}
          className="p-1 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded transition-colors"
          title="Remove time slot"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      )}
    </div>
  );
};

export default TimeSlotInput;
